import { motion } from 'framer-motion';

export default function Reveal({ children, className = '', delay = 0 }) {
  return <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: '-70px' }} transition={{ duration: 0.65, delay: delay / 1000, ease: [0.22, 1, 0.36, 1] }} className={className}>{children}</motion.div>;
}
